<template>
  <a v-bind:href="book.url">
    <div class="bCover" v-bind:style="{backgroundImage: backgroundImage(book.imgUrl_url)}"></div>
    <h3>
      {{book.title}}
      <small>írta: {{book.author}}</small>
    </h3>
    <p>
      <span>{{book.price}} Ft</span><br>
      <strong><span>{{book.available_quantity}}</span>/1000</strong>
    </p>
    <button v-if="button" class="btn btn-primary">Megtekintés</button>
  </a>
</template>

<script>
export default {
  name: 'FrontendBooklink',
  props: {
    button: { type: Boolean },
    book: { type: Object, required: true }
  },
  methods: {
    backgroundImage (_imgUrl) {
      return 'url(' + _imgUrl + ')'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/frontend/partials/booklink.vue